
import * as React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const Add= (props: Props) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.99414 3.2666C10.4083 3.2666 10.744 3.60252 10.7441 4.0166V9.24512H15.9717C16.3859 9.24512 16.7217 9.5809 16.7217 9.99512C16.7217 10.4093 16.3859 10.7451 15.9717 10.7451H10.7441V15.9727C10.7441 16.3869 10.4084 16.7227 9.99414 16.7227C9.57993 16.7227 9.24414 16.3869 9.24414 15.9727V10.7451H4.01562C3.60154 10.745 3.26562 10.4092 3.26562 9.99512C3.26562 9.581 3.60154 9.24527 4.01562 9.24512H9.24414V4.0166C9.24429 3.60252 9.58002 3.2666 9.99414 3.2666Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default Add;